module.exports = __webpack_public_path__ + "img/wild_1.2456e966.png";